
import {ImageData} from '../Classes/Interfaces'
import { defineComponent } from 'vue';
import $ from 'jquery'
type returnData = {
    FileInfo: ImageData[],
    FilteredImages: ImageData[],
    Locations:string[]
}
export default defineComponent(
    {
        data:function():returnData{
            return {
                FileInfo:[],
                FilteredImages:[],
                Locations: ["Outside","Dining Area","Master Bedroom","Guest Bedroom","Master Bathroom","Guest Bathroom","Lounge","Kitchen","Hallway","Various","Balcony","External Hallway"]
            }
        },
        created:function()
        {
            this.init()
        },
        methods:{
            init: function() {
                $(".JumpLink").hide();
                // eslint-disable-next-line
                let self = this;
                $.getJSON("/Data/Data.json",
                    function (data) {
                        self.FileInfo = data.ImageData
                    }
                );
            },
            onAreaClick: function(Number:number) {
                this.FilteredImages = []
                let Tag = this.Locations[Number]
                this.FilteredImages = this.FileInfo.filter(function (e) {
                    return e.Location.includes(Tag);
                })
                // alert(Number)
                this.displaySelectedImages(this.FilteredImages);
                (document.getElementById("LandScapeDisplay")!).scrollIntoView({behavior: 'smooth'});
            },
            displaySelectedImages: function(ImageArray:ImageData[]) {
                let LandScapes = ImageArray.filter(function (e) { return !e.Tags.includes("Portrait") })
                let Portraits = ImageArray.filter(function (e) { return e.Tags.includes("Portrait") })

                this.loadImagesLandScape(LandScapes,"LandScapeDisplay")
                this.loadImagesPortrait(Portraits,"PortraitDisplay")
            },
            loadImagesLandScape: function(Array:ImageData[],ID:string) {
                if(Array.length <= 0)
                {
                    $(`#${ID}`).html(`<div class="FlexCenter"><h1>No Images to Display Currently</h1></div>`)
                    return;
                }
                var ObjectWidth = (document.getElementById(ID)!).offsetWidth
                let ColCount = 3
                if (Array.length < ColCount)
                    ColCount = Array.length
                $(`#${ID}`).css("grid-template-columns",`repeat(${ColCount},1fr)`);
                var ImageWidth = ObjectWidth/ColCount;
                ImageWidth = ImageWidth - screen.width/100;
                var ImageHeight = ImageWidth*0.625;
                ImageHeight = ImageHeight/(screen.width/100)
                let temp = ""
                Array.forEach(element => {
                    temp += `
                    <div style="background-image: url('${element.ImagePath}'); width:100%;height:${ImageHeight}vw;" class="landScapeImage">
                    </div>`
                });
                $(`#${ID}`).html(temp);
            },
            loadImagesPortrait: function(Array:ImageData[],ID:string) {
                if(Array.length <= 0)
                {
                    $(`#${ID}`).html(`<div class="FlexCenter"><h1>No Images to Display Currently</h1></div>`)
                    return;
                }
                var ObjectWidth = (document.getElementById(ID)!).offsetWidth
                let ColCount = 5
                if (Array.length < ColCount)
                    ColCount = Array.length
                $(`#${ID}`).css("grid-template-columns",`repeat(${ColCount},1fr)`);
                var ImageWidth = ObjectWidth/ColCount;
                ImageWidth = ImageWidth - screen.width/100;
                var ImageHeight = ImageWidth*1.6;
                ImageHeight = ImageHeight/(screen.width/100)
                let temp = ""
                Array.forEach(element => {
                    temp += `
                    <div class="flexCenter">
                        <div style="background-image: url('${element.ImagePath}'); width:100%;height:${ImageHeight}vw;" class="PortraitImage">
                        </div>
                    </div>
                    `
                });
                $(`#${ID}`).html(temp);
            }
        }
    }
)
